/**
 * An object representing a Project
 * @typedef {Object} Project
 */

import Model from '../Model';

export default class ProjectModel extends Model {
  constructor(init) {
    super();

    /**
     * only initialize the id field if _id.$oid exists
     **/
    if (init && init._id) this.id = init._id.$oid;
    this.project_type = this.constructor.PROJECT_TYPE();
    this.name = 'project';
    this.shared = [];
    this.owner = null;
    this.last_modified_on = null;
    this.last_modified_by = null;
    this.access_type = 'private';

    this.setProps(init);
  }

  static PROJECT_TYPE() {
    return 'project';
  }

  /**
   * Do not include id when serializing object to JSON
   * to prevent passing an object with a field id to
   * api endpoints.
   */
  toJSON() {
    var obj = Object.assign({}, this);
    delete obj.id;
    return obj;
  }
}
